import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { UiActionToastComponent, UiActionToastData } from './ui-action-toast.component';

/** Opens the dark action toast at the bottom centre of the screen. */
@Injectable({ providedIn: 'root' })
export class UiActionToastService {
  private readonly snackBar = inject(MatSnackBar);

  show(data: UiActionToastData, duration = 5000): MatSnackBarRef<UiActionToastComponent> {
    return this.snackBar.openFromComponent(UiActionToastComponent, {
      data,
      duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: 'ui-action-toast-panel',
    });
  }
}
